import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import FichierObligataire from "../components/FichierObligataire";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}

        {/* Breadcrumb */}
        <Breadcrumb title="Fichier Obligataire" />

        {/* UsersListLayer */}
        <FichierObligataire />


    </>
  );
};

export default UsersListPage; 
